import typography from 'material-ui/styles/typography'
import { grey300 } from 'material-ui/styles/colors'
import { darken, fade, emphasize, lighten } from 'material-ui/utils/colorManipulator'

// https://collaboration.wal-mart.com/display/OPSSG/Color

let palette = {
  primary1Color: '#004C91', // dark blue
  primary2Color: '#367C2B', // dark green
  primary3Color: '#FFC220', // dark yellow
  accent1Color: '#006cce', // light blue
  accent2Color: '#f1681f', // orange
  accent3Color: '#FFD35D', // light yellow
  textColor: '#3b3b3b',
  secondaryTextColor: '#ffffff',
  alternateTextColor: '#a1a1a1',
  grey500: '#9E9E9E',
  grey800: '#424242'
}

let spacing = {
  iconSize: 24,
  desktopGutter: 24,
  desktopGutterMore: 32,
  desktopGutterLess: 16,
  desktopGutterMini: 8,
  desktopKeylineIncrement: 64,
  desktopDropDownMenuItemHeight: 32,
  desktopDropDownMenuFontSize: 15,
  desktopDrawerMenuItemHeight: 48,
  desktopSubheaderHeight: 48,
  desktopToolbarHeight: 56,
}

export const WalmartOnlineTheme = {
  palette: palette,
  spacing: spacing,
  appBar: {
    height: 48,
    padding: 16
  },
  listItem: {
    secondaryTextColor: palette.alternateTextColor
  },
  raisedButton: {
    color: palette.accent2Color,
    textColor: palette.secondaryTextColor,
    disabledColor: fade(palette.accent2Color, 0.4),
    disabledTextColor: palette.secondaryTextColor,
    fontWeight: 700
  }
}

export default WalmartOnlineTheme



// WEBPACK FOOTER //
// ./src/styles/themes/walmartonline/wmonline.js